module.exports = __webpack_public_path__ + "img/spa.aac13143.svg";